module.exports = __webpack_public_path__ + "img/0Q3A4612_L_WoodMatted.877173e4.jpg";